import { TableCell } from "@mui/material";
import { useDrop } from "react-dnd";
import Trophy from "./Trophy";

const TraitSlot = ({ id, trophy, label, onDelete }) => {
  const [, drop] = useDrop(() => ({
    accept: "TROPHY",
    drop: (item) => ({ slotId: id, trophyId: item.id }),
    canDrop: () => true,
  }));

  const [type, empId, trait] = id.split("|");

  const handleDelete = () => {
    onDelete(empId, trait, trophy, type);
  };

  const getBoxColor = (id) => {
    switch (id) {
      case "cleanliness":
        return "!bg-green-100/20 !border-green-400";
      case "reliability":
        return "!bg-blue-100/20 !border-blue-400";
      case "fun":
        return "!bg-orange-100/20 !border-orange-400";
      default:
        return "";
    }
  };

  return (
    <TableCell
      ref={drop}
      id={id}
      className={`h-full group flex overflow-hidden justify-center items-center !py-2 !px-0 min-w-[94px] max-w-[94px] w-[94px] sm:min-w-auto sm:max-w-auto sm:w-auto !border-slate-200/70 ${
        trophy ? "" : ""
      }`}
    >
      <div className="flex justify-center items-center">
        {trophy ? (
          <div className="relative w-[56px] h-[56px]">
            <Trophy id={trophy} isAssigned={true} label={label} />
            <button
              onClick={handleDelete}
              className="absolute -top-1 -right-1 flex sm:hidden group-hover:flex bg-red-300 hover:bg-red-600 text-white rounded-full w-5 h-5  items-center justify-center text-xs"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>
            </button>
          </div>
        ) : (
          <div
            className={`bg-white rounded border-dashed border border-yellow-400 w-[56px] h-[56px] ${
              label ? getBoxColor(label) : ""
            }`}
          ></div>
        )}
      </div>
    </TableCell>
  );
};

export default TraitSlot;
